'use client';
import React, {useState} from 'react';
import CustomCarousel from '@components/CustomCarousel';
import cn from './style.module.scss';
import {Desktop} from '@components/Desktop';
import {Mobile} from '@components/Mobile';
import {ImageObj} from '@custom-types/ImageObj.types';
import Image from 'next/image';

interface CompanyDataProps {
  tabs: Array<{
    heading: string;
    description: string;
    contentIcon: ImageObj[];
    images: Array<ImageObj>;
    mobImages: Array<ImageObj>;
  }>;
}

type Props = {
  layoutClass?: string;
  t: any;
};

export default function CompanyData({
  tabs,
  layoutClass = '',
}: CompanyDataProps & Props) {
  const [activeTab, setActiveTab] = useState(0);

  if (!tabs || tabs.length === 0) return null;

  const currentTab = tabs[activeTab];

  return (
    <div className={`${cn.waldorfCompanyData} ${cn[layoutClass]}`}>
      <div className={cn.waldorfCompanyContent}>
        <div className={cn.waldorfCompanyLogo}>
          <div className={cn.waldorfCompanyLogo__element}>
            <Image
              width={80}
              height={80}
              unoptimized
              quality={100}
              src={currentTab.contentIcon[0].url}
              alt={currentTab.contentIcon[0].alt}
            />
          </div>
        </div>
        <div className={cn.waldorfCompanyHeading}>
          <h2>{currentTab.heading}</h2>
        </div>
        <div className={cn.waldorfCompanyParagraph}>
          <p>{currentTab.description}</p>
        </div>
      </div>

      <div className={cn.waldorfCompanyTheme}>
        <Mobile>
          {currentTab.mobImages.length > 1 ? (
            <CustomCarousel
              dots={false}
              arrows={false}
              fade={true}
              autoplay={true}
              infinite={true}
              speed={1000}
              slidesToScroll={1}
              slidesToShow={1}
              initialSlide={1}
              centerMode={false}
              touchMove={false}>
              {currentTab.mobImages.map((imgObj, idx) => (
                <div
                  className={cn.waldorfThemeElement}
                  key={`${imgObj.name}_${idx}`}>
                  <Image
                    width={500}
                    height={700}
                    unoptimized
                    quality={100}
                    src={imgObj.url}
                    alt={imgObj.alt}
                  />
                </div>
              ))}
            </CustomCarousel>
          ) : (
            currentTab.mobImages[0] && (
              <div className={cn.waldorfThemeElement}>
                <Image
                  width={500}
                  height={700}
                  unoptimized
                  quality={100}
                  src={currentTab.mobImages[0].url}
                  alt={currentTab.mobImages[0].alt}
                />
              </div>
            )
          )}
        </Mobile>

        <Desktop>
          {currentTab.images.length > 1 ? (
            <CustomCarousel
              dots={false}
              arrows={false}
              fade={true}
              autoplay={true}
              infinite={true}
              speed={1000}
              slidesToScroll={1}
              slidesToShow={1}
              initialSlide={1}
              centerMode={false}>
              {currentTab.images.map((imgObj, idx) => (
                <div
                  className={cn.waldorfThemeElement}
                  key={`${imgObj.name}_${idx}`}>
                  <Image
                    width={500}
                    height={700}
                    unoptimized
                    quality={100}
                    src={imgObj.url}
                    alt={imgObj.alt}
                  />
                </div>
              ))}
            </CustomCarousel>
          ) : (
            currentTab.images[0] && (
              <div className={cn.waldorfThemeElement}>
                <Image
                  width={500}
                  height={700}
                  unoptimized
                  quality={100}
                  src={currentTab.images[0].url}
                  alt={currentTab.images[0].alt}
                />
              </div>
            )
          )}
        </Desktop>
      </div>
    </div>
  );
}
